/**
 * Product Featured – Video toggle
 *
 * Custom element <product-featured-video> que gestiona
 * la reproducción / pausa del vídeo en bucle.
 */
class ProductFeaturedVideo extends HTMLElement {
  constructor() {
    super();
    this._video = null;
    this._btn = null;
    this._isPlaying = true;
  }

  connectedCallback() {
    this._video = this.querySelector('[data-product-featured-video]');
    this._btn = this.querySelector('[data-video-toggle]');

    if (!this._video || !this._btn) return;

    this._iconPause = this._btn.querySelector('.product-featured__toggle-icon--pause');
    this._iconPlay = this._btn.querySelector('.product-featured__toggle-icon--play');

    this._btn.addEventListener('click', this._toggle.bind(this));

    // Intersection Observer: pausa cuando sale del viewport, reanuda al volver
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && this._isPlaying) {
              this._video.pause();
            } else if (entry.isIntersecting && this._isPlaying) {
              this._video.play().catch(() => {});
            }
          });
        },
        { threshold: 0.1 }
      );
      this._observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  _toggle() {
    if (this._isPlaying) {
      this._video.pause();
      this._isPlaying = false;
      this._iconPause.classList.add('hidden');
      this._iconPlay.classList.remove('hidden');
      this._btn.setAttribute('aria-pressed', 'true');
      this._btn.setAttribute(
        'aria-label',
        this._btn.dataset.labelPlay || 'Reproducir vídeo'
      );
    } else {
      this._video.play().catch(() => {});
      this._isPlaying = true;
      this._iconPause.classList.remove('hidden');
      this._iconPlay.classList.add('hidden');
      this._btn.setAttribute('aria-pressed', 'false');
      this._btn.setAttribute(
        'aria-label',
        this._btn.dataset.labelPause || 'Pausar vídeo'
      );
    }
  }
}

if (!customElements.get('product-featured-video')) {
  customElements.define('product-featured-video', ProductFeaturedVideo);
}
